import { db } from './firebase';
import { collection, doc, setDoc, getDoc, updateDoc, arrayUnion } from 'firebase/firestore';

const COLLECTIONS = {
  USER_SUGGESTIONS: 'userSuggestions'
};

// Predefined data for AI-like suggestions
const PREDEFINED_DATA = {
  education: [
    // Bachelor's Degrees
    'Bachelor\'s in Computer Science',
    'Bachelor\'s in Information Technology',
    'Bachelor\'s in Software Engineering',
    'Bachelor\'s in Data Science',
    'Bachelor\'s in Artificial Intelligence',
    'Bachelor\'s in Cybersecurity',
    'Bachelor\'s in Electronics Engineering',
    'Bachelor\'s in Electrical Engineering',
    'Bachelor\'s in Mechanical Engineering',
    'Bachelor\'s in Civil Engineering',
    'Bachelor\'s in Chemical Engineering',
    'Bachelor\'s in Aerospace Engineering',
    'Bachelor\'s in Industrial Engineering',
    'Bachelor\'s in Biomedical Engineering',
    'Bachelor\'s in Environmental Engineering',
    'Bachelor\'s in Business Administration',
    'Bachelor\'s in Commerce (B.Com)',
    'Bachelor\'s in Marketing',
    'Bachelor\'s in Finance',
    'Bachelor\'s in Accounting',
    'Bachelor\'s in Economics',
    'Bachelor\'s in Human Resources',
    'Bachelor\'s in Psychology',
    'Bachelor\'s in Sociology',
    'Bachelor\'s in Communications',
    'Bachelor\'s in Journalism',
    'Bachelor\'s in Graphic Design',
    'Bachelor\'s in Architecture',
    'Bachelor\'s in Medicine (MBBS)',
    'Bachelor\'s in Pharmacy',
    'Bachelor\'s in Nursing',
    'Bachelor\'s in Law (LLB)',
    'Bachelor\'s in Education',
    'Bachelor\'s in Mathematics',
    'Bachelor\'s in Physics',
    'Bachelor\'s in Chemistry',
    'Bachelor\'s in Biology',

    // Master's Degrees
    'Master\'s in Computer Science',
    'Master\'s in Information Technology',
    'Master\'s in Data Science',
    'Master\'s in Artificial Intelligence',
    'Master\'s in Machine Learning',
    'Master\'s in Cybersecurity',
    'Master\'s in Software Engineering',
    'Master\'s in Business Administration (MBA)',
    'Master\'s in Digital Marketing',
    'Master\'s in Finance',
    'Master\'s in Project Management',
    'Master\'s in Human Resources',
    'Master\'s in Public Administration',
    'Master\'s in International Business',
    'Master\'s in Supply Chain Management',
    'Master\'s in Operations Management',
    'Master\'s in Healthcare Management',
    'Master\'s in Engineering Management',

    // Professional Degrees
    'PhD in Computer Science',
    'PhD in Engineering',
    'PhD in Business',
    'PhD in Data Science',

    // Diplomas and Certifications
    'Diploma in Computer Science',
    'Diploma in Information Technology',
    'Diploma in Digital Marketing',
    'Diploma in Graphic Design',
    'Diploma in Web Development',
    'Diploma in Mobile App Development',
    'Diploma in Data Analytics',
    'Diploma in Project Management',
    'Diploma in Business Administration',
    'Diploma in Accounting',
    'Diploma in Human Resources',
    'Diploma in Hospitality Management',

    // Professional Certifications
    'AWS Certified Solutions Architect',
    'Google Cloud Professional',
    'Microsoft Azure Certified',
    'Certified Scrum Master (CSM)',
    'Project Management Professional (PMP)',
    'Certified Public Accountant (CPA)',
    'Chartered Financial Analyst (CFA)',
    'Certified Information Systems Security Professional (CISSP)',
    'Certified Ethical Hacker (CEH)',
    'Google Analytics Certified',
    'HubSpot Certified',
    'Salesforce Certified',

    // General Categories
    'Any Engineering Degree',
    'Any Graduate Degree',
    'Any Post Graduate Degree',
    'Any Technical Degree',
    'Any Business Degree',
    'High School Diploma',
    '12th Pass',
    '10th Pass',
  
    'Graduate (Any Stream)',
    'Post Graduate (Any Stream)',
    'other',
  ],

  benefits: [
    'Health Insurance',
    'Life Insurance',
    'Dental Insurance',
    'Vision Insurance',
    'Paid Time Off',
    'Sick Leave',
    'Maternity/Paternity Leave',
    'Flexible Working Hours',
    'Work From Home',
    'Remote Work Options',
    'Professional Development',
    'Training Programs',
    'Conference Attendance',
    'Certification Reimbursement',
    'Tuition Reimbursement',
    'Performance Bonus',
    'Annual Bonus',
    'Stock Options',
    'Equity Participation',
    'Retirement Plans',
    '401(k) Matching',
    'Provident Fund',
    'Free Meals',
    'Snacks & Beverages',
    'Gym Membership',
    'Wellness Programs',
    'Mental Health Support',
    'Employee Assistance Program',
    'Transportation Allowance',
    'Parking Facility',
    'Mobile Reimbursement',
    'Internet Reimbursement',
    'Laptop/Equipment Provided',
    'Team Outings',
    'Company Events',
    'Casual Dress Code',
    'Pet-Friendly Office',
    'Childcare Support',
    'Relocation Assistance'
  ],
  departments: [
    'Human Resources (HR)',
    'Administration',
    'Operations',
    'Sales',
    'Marketing',
    'Digital Marketing',
    'Business Development',
    'Customer Support',
    'Telecalling / Call Center',
    'Back Office',
    'Data Entry',
    'Accounts',
    'Finance',
    'Audit & Compliance',
    'Legal',
    'Purchase / Procurement',
    'Supply Chain Management',
    'Logistics',
    'Warehouse Management',
    'Inventory Management',
    'Transportation',
    'Distribution',
    'Fleet Management',
    'Production',
    'Manufacturing',
    'Quality Control',
    'Quality Assurance',
    'Maintenance',
    'Mechanical',
    'Electrical',
    'Electronics',
    'Engineering',
    'Safety',
    'Packaging',
    'Stores',
    'Skilled Labor',
    'General Labor',
    'Healthcare',
    'Nursing',
    'Medical Services',
    'Pharmacy',
    'Laboratory',
    'Radiology',
    'Hospital Administration',
    'Banking Operations',
    'Loans & Credit',
    'Insurance',
    'Recovery',
    'Microfinance',
    'IT Support',
    'Software Development',
    'Web Development',
    'App Development',
    'Hardware & Networking',
    'Cyber Security',
    'Data Analytics',
    'UI/UX',
    'Technical Support',
    'Retail',
    'E-commerce',
    'Delivery',
    'Field Operations',
    'Security',
    'Facility Management',
    'Housekeeping',
    'Education',
    'Training & Development',
    'School Administration',
    'Media & Communication',
    'Graphic Design',
    'Content Writing',
    'Social Media'
  ],
  skills: [
    'Communication',
    'Basic English',
    'Hindi Communication',
    'Marathi Communication',
    'Teamwork',
    'Time Management',
    'Problem Solving',
    'Customer Handling',
    'Positive Attitude',
    'Punctuality',
    'Basic Computer Knowledge',
    'MS Office',
    'MS Excel',
    'MS Word',
    'Internet Usage',
    'Email Writing',
    'Data Entry',
    'Typing Speed',
    'CRM Handling',
    'Sales Skills',
    'Negotiation Skills',
    'Presentation Skills',
    'Leadership',
    'Recruitment',
    'Payroll Processing',
    'Tally',
    'GST Knowledge',
    'Accounting',
    'Banking Operations',
    'Loan Processing',
    'Insurance Knowledge',
    'Digital Marketing',
    'Social Media Handling',
    'Content Writing',
    'Graphic Designing',
    'Video Editing',
    'Programming',
    'Software Development',
    'Web Development',
    'App Development',
    'IT Support',
    'Technical Support',
    'Hardware & Networking',
    'Cyber Security',
    'Data Analysis',
    'Machine Operation',
    'Production Handling',
    'Quality Checking',
    'Packaging',
    'Loading & Unloading',
    'Inventory Management',
    'Warehouse Handling',
    'Dispatch Handling',
    'Logistics Coordination',
    'Driving',
    'Two Wheeler License',
    'Four Wheeler License',
    'Field Work',
    'Collection Work',
    'Electrical Work',
    'Mechanical Repair',
    'Welding',
    'Plumbing',
    'Carpentry',
    'Housekeeping',
    'Cleaning',
    'Security'
  ]
};

// Skills mapping based on education
const EDUCATION_SKILLS_MAP = {
  'computer science': ['JavaScript', 'Python', 'Java', 'C++', 'C#', 'React', 'Angular', 'Vue.js', 'Node.js', 'Express.js', 'SQL', 'NoSQL', 'MongoDB', 'PostgreSQL', 'Git', 'GitHub', 'Data Structures', 'Algorithms', 'Software Development', 'Database Management', 'Web Development', 'API Development', 'REST APIs', 'GraphQL', 'Microservices', 'Docker', 'Kubernetes'],
  'information technology': ['Network Administration', 'System Administration', 'Cloud Computing', 'AWS', 'Azure', 'Google Cloud', 'DevOps', 'Linux', 'Windows Server', 'Cybersecurity', 'IT Support', 'Database Management', 'Troubleshooting', 'Network Security', 'Server Management', 'Virtualization', 'Active Directory', 'TCP/IP', 'DNS', 'DHCP'],
  'software engineering': ['Software Development', 'Agile Methodology', 'Scrum', 'Kanban', 'Test-Driven Development', 'CI/CD', 'Version Control', 'Code Review', 'Software Architecture', 'Design Patterns', 'Quality Assurance', 'Unit Testing', 'Integration Testing', 'Performance Testing', 'Code Optimization', 'Debugging', 'Refactoring'],
  'data science': ['Python', 'R', 'SQL', 'Machine Learning', 'Deep Learning', 'Neural Networks', 'Statistics', 'Data Analysis', 'Data Visualization', 'Data Mining', 'Big Data', 'Pandas', 'NumPy', 'Scikit-learn', 'TensorFlow', 'PyTorch', 'Tableau', 'Power BI', 'Jupyter', 'Apache Spark', 'Hadoop'],
  'artificial intelligence': ['Machine Learning', 'Deep Learning', 'Neural Networks', 'Natural Language Processing', 'Computer Vision', 'Python', 'TensorFlow', 'PyTorch', 'Keras', 'OpenCV', 'NLTK', 'Scikit-learn', 'Data Science', 'Statistics', 'Mathematics', 'Algorithm Design'],
  'business administration': ['Project Management', 'Strategic Planning', 'Business Analysis', 'Leadership', 'Team Management', 'Communication', 'Presentation Skills', 'Excel', 'PowerPoint', 'CRM', 'ERP', 'Business Intelligence', 'Process Improvement', 'Change Management', 'Stakeholder Management'],
  'commerce': ['Accounting', 'Financial Accounting', 'Cost Accounting', 'Taxation', 'GST', 'Auditing', 'Bookkeeping', 'Tally', 'Excel', 'QuickBooks', 'SAP', 'Financial Analysis', 'Banking', 'Business Law', 'Economics', 'Statistics', 'Business Communication', 'MS Office', 'Data Entry', 'Inventory Management'],
  'marketing': ['Digital Marketing', 'Social Media Marketing', 'Content Marketing', 'SEO', 'SEM', 'Google Analytics', 'Google Ads', 'Facebook Ads', 'Email Marketing', 'Brand Management', 'Market Research', 'Campaign Management', 'Marketing Automation', 'Lead Generation', 'Conversion Optimization'],
  'finance': ['Financial Analysis', 'Financial Modeling', 'Accounting', 'Excel', 'QuickBooks', 'SAP', 'Oracle', 'Risk Management', 'Investment Analysis', 'Budgeting', 'Forecasting', 'Financial Planning', 'Portfolio Management', 'Derivatives', 'Capital Markets'],
  'mechanical engineering': ['CAD', 'SolidWorks', 'AutoCAD', 'CATIA', 'ANSYS', 'MATLAB', 'Project Management', 'Quality Control', 'Manufacturing', 'Design Engineering', 'Problem Solving', 'Lean Manufacturing', 'Six Sigma', 'Product Development', 'Materials Science'],
  'civil engineering': ['AutoCAD', 'Revit', 'SketchUp', 'Project Management', 'Construction Management', 'Structural Analysis', 'Site Planning', 'Quality Control', 'Safety Management', 'Cost Estimation', 'Building Codes', 'Environmental Engineering', 'Transportation Engineering'],
  'electrical engineering': ['Circuit Design', 'PCB Design', 'MATLAB', 'Simulink', 'PLC Programming', 'SCADA', 'Power Systems', 'Control Systems', 'Electronics', 'Embedded Systems', 'Microcontrollers', 'Signal Processing', 'Renewable Energy'],
  'cybersecurity': ['Network Security', 'Information Security', 'Ethical Hacking', 'Penetration Testing', 'Security Auditing', 'Incident Response', 'Risk Assessment', 'Compliance', 'Firewall Management', 'Intrusion Detection', 'Cryptography', 'Security Frameworks'],
  'human resources': ['Recruitment', 'Talent Acquisition', 'Performance Management', 'Employee Relations', 'Compensation & Benefits', 'Training & Development', 'HR Analytics', 'HRIS', 'Labor Law', 'Organizational Development', 'Change Management'],
  'graphic design': ['Adobe Photoshop', 'Adobe Illustrator', 'Adobe InDesign', 'Figma', 'Sketch', 'Typography', 'Color Theory', 'Layout Design', 'Brand Identity', 'UI/UX Design', 'Print Design', 'Digital Design', 'Creative Suite'],
  'web development': ['HTML', 'CSS', 'JavaScript', 'React', 'Angular', 'Vue.js', 'Node.js', 'PHP', 'WordPress', 'Responsive Design', 'Cross-browser Compatibility', 'Web Performance', 'SEO', 'Git'],
  'mobile development': ['iOS Development', 'Android Development', 'React Native', 'Flutter', 'Swift', 'Kotlin', 'Java', 'Objective-C', 'Mobile UI/UX', 'App Store Optimization', 'Mobile Testing']
};

// Roles mapping based on industry and experience level
const INDUSTRY_ROLES_MAP = {
  'technology': {
    'entry': ['Junior Developer', 'Software Trainee', 'IT Support Specialist', 'QA Tester', 'Technical Writer'],
    'mid': ['Software Developer', 'Full Stack Developer', 'DevOps Engineer', 'System Analyst', 'Product Manager'],
    'senior': ['Senior Developer', 'Tech Lead', 'Solution Architect', 'Engineering Manager', 'Principal Engineer'],
    'executive': ['CTO', 'VP Engineering', 'Director of Technology', 'Head of Product']
  },
  'finance': {
    'entry': ['Financial Analyst', 'Accounting Assistant', 'Junior Auditor', 'Credit Analyst'],
    'mid': ['Senior Financial Analyst', 'Finance Manager', 'Investment Analyst', 'Risk Analyst'],
    'senior': ['Finance Director', 'Controller', 'Treasury Manager', 'Senior Investment Manager'],
    'executive': ['CFO', 'VP Finance', 'Finance Director', 'Head of Finance']
  },
  'marketing': {
    'entry': ['Marketing Coordinator', 'Social Media Specialist', 'Content Writer', 'Marketing Assistant'],
    'mid': ['Marketing Manager', 'Digital Marketing Manager', 'Brand Manager', 'Campaign Manager'],
    'senior': ['Senior Marketing Manager', 'Marketing Director', 'Head of Marketing', 'Brand Director'],
    'executive': ['CMO', 'VP Marketing', 'Chief Brand Officer']
  }
};

// Responsibilities mapping based on roles
const ROLE_RESPONSIBILITIES_MAP = {
  'developer': [
    'Write clean, maintainable, and efficient code',
    'Participate in code reviews and maintain code quality',
    'Collaborate with cross-functional teams',
    'Debug and troubleshoot applications',
    'Implement new features and functionality',
    'Maintain and update existing applications',
    'Follow best practices and coding standards',
    'Participate in agile development processes'
  ],
  'manager': [
    'Lead and manage team members',
    'Set goals and objectives for the team',
    'Conduct performance reviews and provide feedback',
    'Coordinate with other departments',
    'Manage project timelines and deliverables',
    'Make strategic decisions for the team',
    'Mentor and develop team members',
    'Report to senior management'
  ],
  'analyst': [
    'Analyze data and generate insights',
    'Create reports and presentations',
    'Identify trends and patterns',
    'Provide recommendations based on analysis',
    'Collaborate with stakeholders',
    'Maintain data quality and accuracy',
    'Use analytical tools and software',
    'Support decision-making processes'
  ]
};

export const getEducationSuggestions = async (userId) => {
  try {
    const userDoc = await getUserSuggestions(userId);
    const customEducation = userDoc?.education || [];
    return [...PREDEFINED_DATA.education, ...customEducation];
  } catch (error) {
    console.error('Error getting education suggestions:', error);
    return PREDEFINED_DATA.education;
  }
};

export const getBenefitsSuggestions = async (userId) => {
  try {
    const userDoc = await getUserSuggestions(userId);
    const customBenefits = userDoc?.benefits || [];
    return [...PREDEFINED_DATA.benefits, ...customBenefits];
  } catch (error) {
    console.error('Error getting benefits suggestions:', error);
    return PREDEFINED_DATA.benefits;
  }
};

export const getDepartmentSuggestions = async (userId) => {
  try {
    const userDoc = await getUserSuggestions(userId);
    const customDepartments = userDoc?.departments || [];
    return [...PREDEFINED_DATA.departments, ...customDepartments];
  } catch (error) {
    console.error('Error getting department suggestions:', error);
    return PREDEFINED_DATA.departments;
  }
};

export const getSkillsSuggestions = (education, userId = null) => {
  const educationLower = education.toLowerCase();
  let skills = [];

  // Find matching skills based on education
  for (const [key, skillList] of Object.entries(EDUCATION_SKILLS_MAP)) {
    if (educationLower.includes(key)) {
      skills = [...skills, ...skillList];
    }
  }

  // If no specific match, provide general skills
  if (skills.length === 0) {
    skills = PREDEFINED_DATA.skills;
  }

  return [...new Set(skills)]; // Remove duplicates
};

export const getPreferredSkillsSuggestions = (requiredSkills, education) => {
  const baseSkills = getSkillsSuggestions(education);
  const preferredSkills = [
    'Advanced Communication',
    'Mentoring',
    'Training',
    'Cross-functional Collaboration',
    'Innovation',
    'Strategic Thinking',
    'Process Improvement',
    'Client Management',
    'Presentation Skills',
    'Documentation',
    'Research Skills',
    'Analytical Thinking'
  ];

  // Filter out already selected required skills
  const filteredPreferred = preferredSkills.filter(skill =>
    !requiredSkills.some(req => req.toLowerCase().includes(skill.toLowerCase()))
  );

  return [...filteredPreferred, ...baseSkills.slice(0, 5)];
};

export const getRolesSuggestions = (industry, experienceLevel, userId = null) => {
  const industryLower = industry.toLowerCase();
  let roles = [];

  // Get roles based on industry and experience level
  for (const [key, levelMap] of Object.entries(INDUSTRY_ROLES_MAP)) {
    if (industryLower.includes(key)) {
      roles = levelMap[experienceLevel] || [];
      break;
    }
  }

  // If no specific match, provide general roles
  if (roles.length === 0) {
    const generalRoles = {
      'entry': ['Junior Executive', 'Associate', 'Trainee', 'Assistant'],
      'mid': ['Executive', 'Specialist', 'Coordinator', 'Officer'],
      'senior': ['Senior Executive', 'Manager', 'Lead', 'Head'],
      'executive': ['Director', 'VP', 'Chief Officer', 'President']
    };
    roles = generalRoles[experienceLevel] || [];
  }

  return roles;
};

export const getResponsibilitiesSuggestions = (roles, experienceLevel) => {
  let responsibilities = [];

  // Get responsibilities based on role type
  roles.forEach(role => {
    const roleLower = role.toLowerCase();
    for (const [key, respList] of Object.entries(ROLE_RESPONSIBILITIES_MAP)) {
      if (roleLower.includes(key)) {
        responsibilities = [...responsibilities, ...respList];
      }
    }
  });

  // Add level-specific responsibilities
  const levelResponsibilities = {
    'entry': [
      'Learn and follow company processes',
      'Complete assigned tasks on time',
      'Seek guidance when needed',
      'Participate in training programs'
    ],
    'mid': [
      'Take ownership of projects',
      'Provide guidance to junior team members',
      'Contribute to process improvements',
      'Handle complex tasks independently'
    ],
    'senior': [
      'Lead strategic initiatives',
      'Make critical decisions',
      'Drive innovation and change',
      'Represent the company externally'
    ],
    'executive': [
      'Set organizational vision and strategy',
      'Make high-level business decisions',
      'Lead organizational transformation',
      'Build strategic partnerships'
    ]
  };

  responsibilities = [...responsibilities, ...(levelResponsibilities[experienceLevel] || [])];

  return [...new Set(responsibilities)]; // Remove duplicates
};

export const generateJobDescription = (formData) => {
  const {
    title,
    company,
    industry,
    experienceLevel,
    location,
    workMode,
    jobType,
    requirements = [],
    responsibilities = [],
    requiredSkills = [],
    preferredSkills = [],
    benefits = [],
    salary,
    education,
    department
  } = formData;

  let description = '';

  // Professional Opening
  description += `🚀 **About the Opportunity**\n\n`;
  description += `${company} is seeking an exceptional ${title} to join our ${department ? department + ' ' : ''}team and drive innovation in the ${industry} sector. `;
  description += `This ${jobType.replace('-', ' ')} position offers the flexibility of ${workMode} work `;
  if (location.city && location.state) {
    description += `based in ${location.city}, ${location.state}`;
    if (location.remote) description += ` with remote work options`;
    if (location.hybrid) description += ` with hybrid work flexibility`;
  }
  description += `.\n\n`;

  // Experience Level Context
  if (experienceLevel) {
    const levelDescriptions = {
      'entry': 'This is an outstanding opportunity for ambitious professionals beginning their career journey, offering mentorship, growth, and hands-on experience with cutting-edge technologies.',
      'mid': 'We are seeking a skilled professional with proven experience who is ready to take on challenging projects and contribute to strategic initiatives while continuing to grow their expertise.',
      'senior': 'This senior-level position is designed for an accomplished professional who can lead complex projects, mentor team members, and drive technical excellence across the organization.',
      'executive': 'We need a visionary leader with extensive experience who can shape strategic direction, build high-performing teams, and drive organizational transformation.'
    };
    description += `**What We\'re Looking For:**\n${levelDescriptions[experienceLevel]}\n\n`;
  }

  // Key Responsibilities
  if (responsibilities.length > 0) {
    description += `**🎯 Key Responsibilities:**\n`;
    responsibilities.slice(0, 6).forEach((resp, index) => {
      description += `• ${resp}\n`;
    });
    if (responsibilities.length > 6) {
      description += `• Drive additional strategic initiatives that align with company objectives\n`;
    }
    description += `\n`;
  }

  // Requirements and Qualifications
  if (requirements.length > 0 || education || requiredSkills.length > 0) {
    description += `**📋 Required Qualifications:**\n`;

    if (education) {
      description += `• ${education} or equivalent experience\n`;
    }

    if (requirements.length > 0) {
      requirements.slice(0, 5).forEach(req => {
        description += `• ${req}\n`;
      });
    }

    if (requiredSkills.length > 0) {
      description += `• **Technical Skills:** Proficiency in ${requiredSkills.slice(0, 6).join(', ')}`;
      if (requiredSkills.length > 6) description += `, and other relevant technologies`;
      description += `\n`;
    }

    description += `\n`;
  }

  // Preferred Qualifications
  if (preferredSkills.length > 0) {
    description += `**⭐ Preferred Qualifications:**\n`;
    preferredSkills.slice(0, 5).forEach(skill => {
      description += `• Experience with ${skill}\n`;
    });
    description += `\n`;
  }

  // Compensation and Benefits
  if (salary?.min || salary?.max || benefits.length > 0) {
    description += `**💰 What We Offer:**\n`;

    if (salary?.min || salary?.max) {
      let salaryText = `• Competitive ${salary.period || 'annual'} compensation`;
      if (salary.min && salary.max) {
        salaryText += ` ranging from ${salary.currency || 'INR'} ${salary.min.toLocaleString()} - ${salary.max.toLocaleString()}`;
      } else if (salary.min) {
        salaryText += ` starting from ${salary.currency || 'INR'} ${salary.min.toLocaleString()}`;
      }
      if (salary.negotiable) {
        salaryText += ` (negotiable based on experience)`;
      }
      description += salaryText + `\n`;
    }

    if (benefits.length > 0) {
      benefits.slice(0, 8).forEach(benefit => {
        description += `• ${benefit}\n`;
      });
      if (benefits.length > 8) {
        description += `• And many more exciting perks and benefits\n`;
      }
    }

    description += `\n`;
  }

  // Company Culture and Growth
  description += `**🌟 Why Join ${company}?**\n`;
  description += `• Work with cutting-edge technology and innovative solutions\n`;
  description += `• Collaborate with a diverse, talented, and passionate team\n`;
  description += `• Opportunities for professional development and career advancement\n`;
  description += `• Make a meaningful impact in the ${industry} industry\n`;
  description += `• Enjoy a supportive and inclusive work environment\n\n`;

  // Call to Action
  description += `**🚀 Ready to Take the Next Step?**\n`;
  description += `If you\'re passionate about ${industry.toLowerCase()} and ready to contribute to groundbreaking projects, we\'d love to hear from you! Join us in shaping the future of technology and advancing your career with endless possibilities.\n\n`;
  description += `*${company} is an equal opportunity employer committed to diversity and inclusion.*`;

  return description.trim();
};

// Firebase operations
export const getUserSuggestions = async (userId) => {
  try {
    const docRef = doc(db, COLLECTIONS.USER_SUGGESTIONS, userId);
    const docSnap = await getDoc(docRef);
    return docSnap.exists() ? docSnap.data() : null;
  } catch (error) {
    console.error('Error getting user suggestions:', error);
    return null;
  }
};

export const saveCustomSuggestion = async (userId, type, value) => {
  try {
    const docRef = doc(db, COLLECTIONS.USER_SUGGESTIONS, userId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      await updateDoc(docRef, {
        [type]: arrayUnion(value),
        updatedAt: new Date()
      });
    } else {
      await setDoc(docRef, {
        [type]: [value],
        createdAt: new Date(),
        updatedAt: new Date()
      });
    }

    return { success: true };
  } catch (error) {
    console.error('Error saving custom suggestion:', error);
    return { success: false, error: error.message };
  }
};

export const saveMultipleSuggestions = async (userId, data) => {
  try {
    const docRef = doc(db, COLLECTIONS.USER_SUGGESTIONS, userId);
    const docSnap = await getDoc(docRef);

    const updateData = { updatedAt: new Date() };

    // Add each type of data
    Object.keys(data).forEach(type => {
      if (data[type] && data[type].length > 0) {
        updateData[type] = arrayUnion(...data[type]);
      }
    });

    if (docSnap.exists()) {
      await updateDoc(docRef, updateData);
    } else {
      await setDoc(docRef, {
        ...updateData,
        createdAt: new Date()
      });
    }

    return { success: true };
  } catch (error) {
    console.error('Error saving multiple suggestions:', error);
    return { success: false, error: error.message };
  }
};
